import { ColumnsType } from "antd/lib/table";

import DataTable from "./DataTable";

import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";

function MyOwnCar({ ownCar }: { ownCar?: Array<Types.CarOwnerDto> }) {
    const ownCars: ColumnsType<Types.CarOwnerDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            render: (item, record, index) => <>{ownCar && ownCar.indexOf(record) + 1}</>,
        },
        {
            align: "center",
            title: "등록일",
            dataIndex: "createdDate",
            render: (_, row) => <>{row.createdDate || String.dash}</>,
        },
        {
            align: "center",
            title: "등록분류",
            dataIndex: "ownType",
            render: (_, row) => <>{row.ownType === "ORDER" ? "구매 차량" : row.ownType === "SELF" ? "개인 등록" : "other"}</>,
        },
        {
            align: "center",
            title: "제조사",
            dataIndex: "makerName",
            render: (_, row) => <>{(row.car && row.car.makerName) || String.dash}</>,
        },
        {
            align: "center",
            title: "차량번호",
            dataIndex: "carNumber",
            render: (_, row) => <>{(row.car && row.car.carNumber) || String.dash}</>,
        },
        {
            align: "center",
            title: "차량모델",
            dataIndex: "carModel",
            render: (_, row) => <>{row.car?.carType?.model?.modelName || String.dash}</>,
        },
        {
            align: "center",
            title: "차량타입",
            dataIndex: "carType",
            render: (_, row) => <>{row.car?.carType?.typeName || String.dash}</>,
        },
    ];
    return <DataTable hasScroll={false} columns={ownCars} rowKey="num" dataSource={ownCar} />;
}
export default MyOwnCar;
